import queryString from "qs";

import {
  getSummarizedDataState,
  getActionDataStateSelector,
  getActionsDataStatesSelector,
} from "altus-datastate";

import { createSelector } from "utils/app.util";

const getCurrentPathnameSelector = state =>
  state.getIn(["router", "location", "pathname"]);

const getCurrentUserSelector = state => state.getIn(["app", "currentUser"]);

export const getActionDataStateFromState = createSelector(
  getActionDataStateSelector,
  dataState => dataState,
);

export const getSummarizedDataStatesFromState = createSelector(
  getActionsDataStatesSelector,
  getSummarizedDataState,
);

export const getActionsDataStatesFromState = createSelector(
  getActionsDataStatesSelector,
  dataStates => dataStates,
);

export const getCurrentPathnameFromState = createSelector(
  getCurrentPathnameSelector,
  pathname => pathname,
);

export const getCurrentUserFromState = createSelector(
  getCurrentUserSelector,
  currentUser => currentUser,
);

export const isPanelOpen = createSelector(
  (state, panelId) => !!state.hasIn(["app", "openPanels", panelId]),
  open => open,
);

export const getRouterFromState = createSelector(
  state => state.get("router"),
  router => router,
);

export const getRouterParamsFromState = createSelector(
  getRouterFromState,
  router =>
    queryString.parse(router.getIn(["location", "search"]), {
      ignoreQueryPrefix: true,
    }),
);

const getFormInitialValueSelector = (state, formId, field) =>
  state.getIn(["form", formId.toString(), "initial", field]);

export const getFormInitialValueFromState = createSelector(
  getFormInitialValueSelector,
  value => value,
);

const appRolesSelector = state => state.getIn(["app", "appRoles"]);

export const getAppRolesFromState = createSelector(
  appRolesSelector,
  appRoles => appRoles,
);

const getUsersSelector = state => state.getIn(["app", "users"]);

export const getUsersFromState = createSelector(getUsersSelector, users =>
  users
    .map(user => user.update("appRoles", appRoles => appRoles.sort()))
    .toList(),
);

export const getUserFromState = createSelector(
  (state, userId) => state.getIn(["app", "users", userId.toString()]),
  user => user,
);

const getApplicationFailureSelector = state =>
  state.getIn(["app", "appFailure"]);

export const getApplicationFailureFromState = createSelector(
  getApplicationFailureSelector,
  applicationFailure => applicationFailure,
);

export const getFormValuesFromState = createSelector(
  (state, formId) => state.getIn(["form", formId.toString(), "values"]),
  values => values,
);

export const getFormValueFromState = createSelector(
  (state, formId, name) =>
    state.getIn(["form", formId.toString(), "values", name]),
  value => value,
);

export const getCurrentUserAppRolesFromState = createSelector(
  state => state.getIn(["app", "currentUser", "appRoles"]),
  appRoles => appRoles,
);
